import { InputUpdateExternalEventsDestinationApi } from "lib/types/generated/graphql-types"

export enum FilterMode {
  ALL,
  SELECT
}

export type ApiDestinationUpdateInputs = {
  destName: string
  options: InputUpdateExternalEventsDestinationApi
}
